import { API_URL } from '../../config';
import { CALL_API } from '../../middlewares/apiMiddleware';
import { DELETE_RESERVATION_DELETE, PENDING, FULFILLED, REJECTED } from '../../globals';



export function deleteReservationRequest(){
  return {
    type: `${DELETE_RESERVATION_DELETE}_${PENDING}`,
  };
}

export function deleteReservationSuccess(response){
  return {
    type: `${DELETE_RESERVATION_DELETE}_${FULFILLED}`,
  };
}

export function deleteReservationFailure(response){
  return {
    type: `${DELETE_RESERVATION_DELETE}_${REJECTED}`,
    payload: {
      time: (response.response && response.response.data.message.message.time !== undefined) ? response.response.data.message.message.time : true,
      completed: (response.response && response.response.data.message.message.completed !== undefined) ? response.response.data.message.message.completed : true,
      deleted: (response.response && response.response.data.message.message.deleted !== undefined) ? response.response.data.message.message.deleted : true,
      emailConfirmed: (response.response && response.response.data.message.message.email_confirmed !== undefined) ? response.response.data.message.message.email_confirmed : true,
    }
  };
}



export const deleteReservation = (reservationHash) => ({
  [CALL_API]: {
    actions: [deleteReservationRequest, deleteReservationSuccess, deleteReservationFailure],
    url: `${API_URL}/web/order/delete-reservation?hash=${reservationHash}`,
  },
});
